import { HTTPError } from "ky";
import { obterErroApi } from "@/utils/errors/apiError";
import { getStatusError } from "@/utils/utils";

// ------------------------------- FUNCTIONS -------------------------------
export function obterSegundosBloqueioLogin(error: unknown): number | null {
	if (!(error instanceof HTTPError) || error.response.status !== 429) return null;

	const cabecalho = error.response.headers.get("Retry-After");
	if (cabecalho === null || !/^\d+$/.test(cabecalho.trim())) return null;

	const segundos = Number(cabecalho);

	return Number.isSafeInteger(segundos) ? segundos : null;
}

export function obterMensagemErroLogin(error: unknown, contexto: "codigo" | "identificado" | "otp"): string {
	const status = getStatusError(error);

	if (status === 401) {
		if (contexto === "otp") return "Código de verificação inválido. Tente novamente.";
		if (contexto === "codigo") return "Código do grupo, usuário ou senha incorretos. Confira os três campos.";
		return "Usuário ou senha incorretos. Confira os dois campos.";
	}

	if (status === 429) return "Muitas tentativas sem sucesso. Aguarde para tentar novamente.";

	const corpo = obterErroApi(error);

	if (corpo) return corpo.message;
	if (status === 403) return "Verificação de segurança recusada. Tente novamente.";
	if (status === 422) return "Dados inválidos. Confira os campos e tente novamente.";
	if (error instanceof Error && !(error instanceof HTTPError)) return error.message;

	return "Não foi possível concluir a autenticação. Verifique sua conexão e tente novamente.";
}

export function formatarEsperaLogin(segundos: number): string {
	const minutos = Math.floor(segundos / 60);
	return `${minutos}:${String(segundos % 60).padStart(2, "0")}`;
}
